<template>
  <v-card data-qa="relatedpartylist-card-ty9ut7">
    <v-card-title data-qa="relatedpartylist-card-title-bmuey9"  class="role-card-title" v-text=resource.relatedParty />
    <v-card-text data-qa="relatedpartylist-card-text-cnc7bb">
      <v-data-table
        @click:row="handleRowClick"
        :headers="headers"
        :items="relatedCustomers"
        :item-class="itemClass"
        :footer-props="{
          'items-per-page-options': [10],
          'disable-items-per-page': true,
        }"
        data-qa="relatedpartylist-data-table-60bewe">
        <template #footer.prepend>
          <v-spacer data-qa="relatedpartylist-spacer-a9hg5"  />
        </template>
        <template v-slot:no-data>
          <v-row justify="center" align="center" no-gutters data-qa="relatedpartylist-row-6cp9t4">
            <v-col cols="12" class="text-center" data-qa="relatedpartylist-col-jy9cyq">
              <v-icon x-large class="mr-2" color="gray" data-qa="relatedpartylist-icon-q9sls">
                mdi-file-account-outline
              </v-icon>
            </v-col>
            <v-col cols="12" class="text-center" data-qa="relatedpartylist-col-wvzm1n">
              <span class="font-weight-bold subtitle-1 black--text" data-qa="relatedpartylist-span-kmcjid">
                {{ resource.noRelatedParty }}
              </span>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import '@/styles/pages/roles/roles.scss'
import commonService from '../../service/commonService'

export default {
  name: 'RelatedPartyList',
  // refreshKey is used to refresh the data in the table.
  // For every change it calls the getRelatedParty method to get the new set of party list from the API
  // This enables the parent component to control when to retrieve a new list
  props: {
    refreshKey: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      relatedCustomers: [],
      corporateId: JSON.parse(sessionStorage.getItem('corporateId')),
      selectedRelatedPartyId: null
    }
  },
  async created () {
    await this.getRelatedParty()
  },
  methods: {
    async getRelatedParty () {
      const response = await commonService.getCustomerDetails(this.corporateId)
      this.relatedCustomers = response.basicDetails?.relationshipDetails
        ?.filter(item => !this.excludedRelations.includes(item.relationshipType))
        .map(item => ({
          ...item,
          relationshipType: item.relationshipType
            .replace('@', '/')
            .toLowerCase()
            .replace(/\/(.)/g, (_, char) => char.toUpperCase())
            .replace(/(^[a-z])/, (match) => match.toUpperCase())
            .split(/(?=[A-Z])/)
            .join('/')
        })
        )
    },
    handleRowClick (party) {
      this.selectedRelatedPartyId = party.relatedPartyId
      this.$emit('onRowClick', party)
    },
    itemClass (party) {
      return party.relatedPartyId === this.selectedRelatedPartyId ? 'selected-row' : ''
    }
  },
  computed: {
    excludedRelations () {
      return [
        'SUBSIDIARY COMPANY@PARENT COMPANY',
        'PARENT COMPANY@SUBSIDIARY COMPANY'
      ]
    },
    resource () {
      return {
        relatedParty: this.$t('smeRoles.relatedParty'),
        noRelatedParty: this.$t('smeRoles.noRelatedParty')
      }
    },
    headers () {
      return [
        { text: 'Name', value: 'relatedPartyName' },
        { text: 'Relationship', value: 'relationshipType' }
      ]
    }
  },
  watch: {
    refreshKey () {
      this.getRelatedParty()
      this.selectedRelatedPartyId = null
    }
  }
}
</script>
